import { useState, useEffect } from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { Mail, Loader2 } from "lucide-react";

export const EmailProviderSwitch = () => {
  const [isBrevo, setIsBrevo] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    fetchProvider();
  }, []);

  const fetchProvider = async () => {
    try {
      const { data, error } = await supabase
        .from("system_settings" as any)
        .select("value")
        .eq("key", "email_provider")
        .single();

      if (error) throw error;
      setIsBrevo((data as any)?.value === "brevo");
    } catch (error) {
      console.error("Error fetching email provider:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (checked: boolean) => {
    setUpdating(true);
    const newProvider = checked ? "brevo" : "resend";

    try {
      const { error } = await supabase
        .from("system_settings" as any)
        .update({ value: newProvider, updated_at: new Date().toISOString() } as any)
        .eq("key", "email_provider");

      if (error) throw error;

      setIsBrevo(checked);
      toast({
        title: "Proveedor actualizado",
        description: `El proveedor de email ahora es ${newProvider === "brevo" ? "Brevo" : "Resend"}.`,
      });
    } catch (error) {
      console.error("Error updating email provider:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo actualizar el proveedor de email.",
      });
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span className="text-sm">Cargando configuración...</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between p-4 rounded-lg border border-border bg-card/50">
      <div className="flex items-center gap-3">
        <Mail className="h-5 w-5 text-primary" />
        <div>
          <Label className="text-sm font-medium">Proveedor de Email</Label>
          <p className="text-xs text-muted-foreground">
            {isBrevo ? "Brevo" : "Resend"} está activo
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-xs text-muted-foreground">Resend</span>
        <Switch
          checked={isBrevo}
          onCheckedChange={handleToggle}
          disabled={updating}
        />
        <span className="text-xs text-muted-foreground">Brevo</span>
      </div>
    </div>
  );
};
